import './personArchive.less';

import { addCalendarDays } from "../../misc/DateCalculator";
import { todayDate } from "../../misc/utility";

angular.module("twshared").controller('PersonArchiveController', ['$uibModalInstance', 'tromanGlobals', 'persons', function ($uibModalInstance, tromanGlobals, persons) {

    this.count = persons.length;
    this.enableUnpublish = true;

    this.clearContact = false;
    this.unpublish = false;
    this.deleteFiles = false;

    if (persons.length === 1) {
        this.target = persons[0].name;
        this.enableUnpublish = !persons[0].Publish?.DisablePublish;
    } else {
        this.target = `${persons.length} personer`;
    }

    this.isPolitikerEnabled = tromanGlobals.systemInfo.IsPolitikerEnabled;
    this.terminatePolitiker = this.isPolitikerEnabled;
    this.politikerExpireDate = addCalendarDays(todayDate(), tromanGlobals.systemInfo.PolitikerReportingDays);

    this.cancel = function () {
        $uibModalInstance.dismiss("cancelled");
    };

    this.canOk = function () {
        return this.form && this.form.$valid;
    };

    this.ok = function () {
        $uibModalInstance.close({
            clearContact: this.clearContact,
            deleteFiles: this.deleteFiles,
            unpublish: this.unpublish,
            politikerExpireDate: this.terminatePolitiker ? this.politikerExpireDate : null,
        });
    };

}]);
